import React from "react";
import { SortableContainer } from "react-sortable-hoc";
import SortableImage from "../SortableImage";

import "./_style.scss";

const SortableImageList = SortableContainer(({
  items, onClick, children, placeholders,
}) => (
  <ul className="sortable-list">
    {
        items.map((value, index) => (
          <SortableImage
            key={`item-${index}`}
            primaryItem={index === 0}
            index={index}
            value={value}
            onClick={onClick}
          />
        ))
      }
    { children }
    { placeholders }
  </ul>
));

export default SortableImageList;
